import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, throwError } from 'rxjs';
import { PANIC_ENDPOINTS } from '../../constants/api/api-endpoints';
import { ApiService } from './api-base.service';

/**
 * Payload completo do panicEvent. Sem email/telefone do morador —
 * só dados operacionais pra popup. Quem precisa de contato abre a tela cheia.
 */
export interface PanicEventPayload {
    id: string;
    status: 'OPEN' | 'ATTENDED' | 'RESOLVED' | 'CANCELLED';
    dateTime: string;
    attendedAt: string | null;
    resolvedAt: string | null;
    description: string | null;
    latitude: number | null;
    longitude: number | null;
    post: { id: string; name: string } | null;
    resident: {
        id: string;
        name: string;
        address: string | null;
    } | null;
}

/**
 * Service do panicEvent. Endpoint unificado: GET /panic-events/:id.
 * O alert-popup usa pra renderizar detalhes contextuais do panic atual.
 */
@Injectable({ providedIn: 'root' })
export class PanicEventsService {
    private readonly apiService = inject(ApiService);

    /**
     * Busca payload completo do panicEvent pra alert-popup. Endpoint sem CASL,
     * path dedicado (/panic-events/popup/:id) pra evitar conflito com o
     * UniversalController que tem @Get(':id') no path raiz.
     */
    buscar(id: string): Observable<PanicEventPayload> {
        return this.apiService
            .get<PanicEventPayload>(PANIC_ENDPOINTS.POPUP(id))
            .pipe(
                catchError((err) => {
                    console.error('Erro ao buscar panicEvent:', err);
                    return throwError(() => err);
                }),
            );
    }
}
